import { useEffect, useState } from "react";
import { SoundOutlined } from "@ant-design/icons";
import moment from "jalali-moment";

const POLL_MS = 5 * 60 * 1000;

// "1405/07/09" or "1405/07/09 08:30[:00]" (Persian digits ok), Tehran time; a date without time covers the whole day.
// Anything unparsable gives an Invalid Date, so that item is simply not shown.
export const parseShamsi = (value, endOfDay = false) => {
	const s = String(value ?? "").replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d)).trim();
	const m = s.match(/^(\d{4})[/-](\d{1,2})[/-](\d{1,2})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);
	if (!m) return new Date(NaN);
	const day = moment.from(`${m[1]}/${m[2]}/${m[3]}`, "fa", "YYYY/M/D");
	if (!day.isValid()) return new Date(NaN);
	const [h, min, sec] = m[4] ? [m[4], m[5], m[6] ?? "00"] : endOfDay ? ["23", "59", "59"] : ["00", "00", "00"];
	return new Date(`${day.locale("en").format("YYYY-MM-DD")}T${h.padStart(2, "0")}:${min}:${sec}+03:30`);
};

// Aptel 10th birthday festival: the party hat and "Happy Birthday!" on the logo switch themselves off after this day
export const isAptelBirthday = () => new Date() <= parseShamsi("1405/08/16", true);

// Shamsi fields win; the Gregorian startDate/endDate still work for older files
const startOf = (i) => (i.startDateShamsi ? parseShamsi(i.startDateShamsi) : new Date(i.startDate));
const endOf = (i) => (i.endDateShamsi ? parseShamsi(i.endDateShamsi, true) : new Date(i.endDate));

export const activeTickerItems = (items = [], now = new Date()) =>
	items.filter((i) => i?.active && startOf(i) <= now && now <= endOf(i)).sort((a, b) => a.priority - b.priority);

// ponytail: local public/ticker.json for now; set REACT_APP_TICKER_URL to the CDN/CMS endpoint later
const ANNOUNCEMENTS_URL = process.env.REACT_APP_TICKER_URL || process.env.PUBLIC_URL + process.env.REACT_APP_PATH + "/ticker.json";

// shared by the ticker and the dashboard popup; null on any network/JSON error
export const fetchAnnouncements = async () => {
	try {
		// no-store + unique query string: browser and CDN must never serve a cached copy
		const sep = ANNOUNCEMENTS_URL.includes("?") ? "&" : "?";
		const res = await fetch(`${ANNOUNCEMENTS_URL}${sep}v=${Date.now()}${Math.random().toString(36).slice(2, 8)}`, { cache: "no-store" });
		return res.ok ? await res.json() : null;
	} catch {
		return null;
	}
};

export const Ticker = () => {
	const [items, setItems] = useState([]);

	useEffect(() => {
		const load = async () => {
			const data = await fetchAnnouncements();
			// on error keep whatever is currently shown
			if (data) setItems(activeTickerItems(data.items).filter((i) => i.text));
		};
		load();
		const timer = setInterval(load, POLL_MS);
		return () => clearInterval(timer);
	}, []);

	if (!items.length) return null;

	const length = items.reduce((sum, i) => sum + i.text.length, 0);
	return (
		<div className="ticker-announcement" role="region" aria-label="اطلاعیه‌ها">
			<span className="ticker-label">
				<SoundOutlined aria-hidden="true" />
				<span className="ticker-label-text">اطلاعیه</span>
			</span>
			<div className="ticker-viewport">
				<div className="ticker-track" style={{ animationDuration: `${Math.max(15, length * 0.2)}s` }}>
					{items.map((i) => (
						<span key={i.id ?? i.text} className="ticker-item">
							{i.text}
						</span>
					))}
				</div>
			</div>
		</div>
	);
};
